import { SocialsSharing } from "./SocialsSharing";

export { SocialsSharing };
